import { FC, useEffect } from 'react'

import { SubmitReassignHeader } from './SubmitReassignHeader'
import { SubmitReassignForm } from './SubmitReassignForm'
import { Application } from '../../../core/applications'


type Props = {
  appData: Application
  reviewId?: number
  doClose: Function        
}

const SubmitReassignModal: FC<Props> = ({ appData, reviewId, doClose }) => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
  <>
  <div
    className='modal fade show d-block'
    id='kt_modal_reassign_application'
    role='dialog'
    tabIndex={-1}
    aria-modal='true'
  >    
  <div className='modal-dialog modal-dialog-centered mw-400px'>    
      <div className='modal-content'>
        <SubmitReassignHeader reviewId={reviewId} doClose={doClose} />                
        <div className='modal-body scroll-y'>
          <SubmitReassignForm 
            appData={appData}
            reviewId={reviewId}
            doClose={doClose}                         
          />
        </div>                
      </div>        
    </div>            
  </div>    
  <div className='modal-backdrop fade show'></div>    
  </>
  )
}

export {SubmitReassignModal}
